import React from "react";
import { useField } from "formik";

const TextInput = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);
  return (
    <div
      className={`relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] px-9 flex items-center h-[70px] transition-all ${
        !meta.error && meta.touched ? "border-2 border-green-400" : null
      } ${meta.error && meta.touched ? "border-2 border-red-400" : null} `}
    >
      <input {...field} {...props} />
      {props.isrequired && <span className=" absolute right-4 top-4">*</span>}
    </div>
  );
};

export default TextInput;
